<div class="container flex-row mt-70 h250-mobile" style="height: 380px;">
  <div id="demo" class="carousel" data-ride="carousel" >

    <!-- Indicators -->
    <ul class="carousel-indicators">
      <li data-target="#demo" data-slide-to="0" class="active"></li>
      <li data-target="#demo" data-slide-to="1"></li>
      <li data-target="#demo" data-slide-to="2"></li>
    </ul>

    <!-- The slideshow -->
    <div class="carousel-inner">
      <h3 class="mb-4">Отзывы клиентов</h3>
      <div class="carousel-item active">
        <div style="display: flex; gap: 20px;">
        <img src="../../../assets/reviews-cards/img.png" style="height: 240px;" alt="">
        <img src="../../../assets/reviews-cards/img_1.png" style="height: 240px;" alt="">
        <img src="../../../assets/reviews-cards/img_2.png" style="height: 240px;" alt="">
        <img src="../../../assets/reviews-cards/img_3.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_5.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_6.png" style="height: 240px;" alt="">
          </div>
      </div>
      <div class="carousel-item ">
        <div style="display: flex; gap: 20px;">
          <img src="../../../assets/reviews-cards/img_4.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_5.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_6.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_1.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_2.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_3.png" style="height: 240px;" alt="">
        </div>
      </div>
      <div class="carousel-item ">
        <div style="display: flex; gap: 20px;">
          <img src="../../../assets/reviews-cards/img_2.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_3.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_2.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_3.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_5.png" style="height: 240px;" alt="">
          <img src="../../../assets/reviews-cards/img_6.png" style="height: 240px;" alt="">
        </div>
      </div>
<!--      <div class="carousel-item">-->
<!--        <h4>Компания "Ай Би Эй"</h4>-->
<!--        <p style="color: black">-->
<!--          Компания "Ай Би Эй" выражает благодарность ООО "Протос Групп"-->
<!--          за помощь в получении лицензии Федеральной службы-->
<!--          по экологическому, технологическому и атомному надзору (Ростехнадзор).-->
<!--        </p>-->
<!--      </div>-->
<!--      <div class="carousel-item">-->
<!--        <h4>ООО "Ника Арт"</h4>-->
<!--        <p style="color: black">-->
<!--          ООО "Ника Арт" выражает глубокую благодарность Вашему коллективу-->
<!--          за неоценимую помощь в подготовке наших людей для прохождения-->
<!--          аттестации реставраторов в Министерстве Культуры Российской Федерации.-->

<!--        </p>-->
<!--        <p style="color: black">-->
<!--          Отметим Вашу высокую квалификацию, четкую организацию процесса, внимательное отношение! Надеемся,-->
<!--          что в будущем наше сотрудничество будет лишь укрепляться и станет еще более длительным и плодотворным.-->
<!--        </p>-->
<!--      </div>-->
<!--      <button class="btn btn_success show-review">Перейти на страницу отзыва</button>-->
    </div>

    <!-- Left and right controls -->
    <a class="carousel-control-prev" href="#demo" data-slide="prev">
      <span class="carousel-control-prev-icon"></span>
    </a>
    <a class="carousel-control-next" href="#demo" data-slide="next">
      <span class="carousel-control-next-icon"></span>
    </a>

  </div>
</div>
